// extracted by mini-css-extract-plugin
export default {"tituloFavorito":"Favoritos_tituloFavorito__YF4Ae"};